import type React from 'react';

import { Button, Image, Text } from '@change/ds-core-ui';

import { useGetStaticAssetUrl } from '@change-corgi/core-react/assets';
import { Translate, TypedTranslate } from '@change-corgi/core-react/i18n';

import { HOW_WORKS_LIST } from '#src/app/pages/about/main/shared/consts';

export const HowChangeWorks: React.FC = () => {
	const getStaticAssetUrl = useGetStaticAssetUrl();
	return (
		<div className="bg-fill-inverse-weak mt-8 py-8">
			<div className="container text-center">
				<div className="flex flex-col items-center justify-center">
					<Image
						src={getStaticAssetUrl('/brand-pages/about/icons/icons-about-megaphone-sunrise.svg')}
						alt=""
						className="mt-[-64px] ml-8 h-24 w-24 object-contain"
					/>
					<Text as="h3" variant="heading" size="xx-small" className="my-8 uppercase">
						<Translate value="fe.pages.about.section_campaign.header" />
					</Text>
					{HOW_WORKS_LIST.map((item, idx) => (
						<div className="flex flex-col items-center justify-center" key={idx}>
							<Text className="text-size-body-large-bold" as="p">
								<TypedTranslate value={item.title} />
							</Text>
							<Text as="p" size="small" className="mt-2 max-w-md">
								<TypedTranslate value={item.description} />
							</Text>
							{idx < HOW_WORKS_LIST.length - 1 && (
								<Image
									src={getStaticAssetUrl('/brand-pages/about/icons/icons-about-handrawn-arrow-sunrise.svg')}
									alt=""
									className="my-4 h-8 w-8"
								/>
							)}
						</div>
					))}
					<Button as="a" href="/impact" variant="primary" className="my-8" data-qa="about-how-change-works-button">
						<Translate value="fe.pages.about.section_victories.button" />
					</Button>
				</div>
			</div>
		</div>
	);
};
